import { render, staticRenderFns } from "./DealerCreateForm.vue?vue&type=template&id=84108190&"
import script from "./DealerCreateForm.vue?vue&type=script&lang=js&"
export * from "./DealerCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports